export default "__VITE_PUBLIC_ASSET__d2e8ff21__"